module.exports = __webpack_public_path__ + "img/pin-grua.881b47a1.png";